import { useMemo } from 'react'

import {
  BasicTextStyleButton,
  BlockTypeSelect,
  ColorStyleButton,
  CreateLinkButton,
  FormattingToolbar,
  FileReplaceButton,
  TextAlignButton,
  blockTypeSelectItems,
  useDictionary
} from '@blocknote/react'

const UNSUPPORTED_BLOCK_TYPE_ITEMS = [
  'Heading 4',
  'Heading 5',
  'Heading 6',
  'Toggle Heading 1',
  'Toggle Heading 2',
  'Toggle Heading 3'
]

export const CustomFormattingToolbar = () => {
  const dict = useDictionary()
  const selectItems = blockTypeSelectItems(dict)

  const supportedSelectItems = useMemo(() => {
    return selectItems.filter(
      item => !UNSUPPORTED_BLOCK_TYPE_ITEMS.includes(item.name)
    )
  }, [selectItems])

  return (
    <FormattingToolbar>
      <BlockTypeSelect key={'blockTypeSelect'} items={supportedSelectItems} />
      <FileReplaceButton />
      <BasicTextStyleButton basicTextStyle={'bold'} key={'boldStyleButton'} />
      <BasicTextStyleButton
        basicTextStyle={'italic'}
        key={'italicStyleButton'}
      />
      <BasicTextStyleButton
        basicTextStyle={'underline'}
        key={'underlineStyleButton'}
      />
      <BasicTextStyleButton
        basicTextStyle={'strike'}
        key={'strikeStyleButton'}
      />
      <TextAlignButton textAlignment={'left'} key={'textAlignLeftButton'} />
      <TextAlignButton textAlignment={'center'} key={'textAlignCenterButton'} />
      <TextAlignButton textAlignment={'right'} key={'textAlignRightButton'} />
      <ColorStyleButton key={'colorStyleButton'} />
      <CreateLinkButton key={'createLinkButton'} />
    </FormattingToolbar>
  )
}
